import axios from "axios";

axios.defaults.headers.common = {
    "X-Requested-With": "XMLHttpRequest",
    "Access-Control-Allow-Origin": "*",
    "crossorigin": "true",
    "X-Frame-Options": "DENY",
};

axios.defaults.credentials = "same-origin";
axios.defaults.baseURL = `${process.env.REACT_APP_LIVE_URL}`;
axios.defaults.headers.post["Content-Type"] = "application/json";
